import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[numericOnly]'
})
export class NumericOnlyDirective implements OnInit, OnDestroy {
    valueSubscription!: Subscription;
    @Input() numericOnly: number = 1000;

    constructor(public ngControl: NgControl) {}

    ngOnInit(): void {
        this.valueSubscription = this.ngControl.control!.valueChanges.subscribe((value) => {
            const newVal = this.transform(value);
            this.ngControl.control!.setValue(newVal, { emitEvent: false });
        });
    }

    transform(value: any) {
        let transformedInput = value ? value.replace(/[^\d]/g, '') : null;
        if (transformedInput && !isNaN(+this.numericOnly)) {
            transformedInput = transformedInput.substring(0, this.numericOnly);
        }

        return transformedInput;
    }

    ngOnDestroy(): void {
        this.valueSubscription.unsubscribe();
    }
}
